import { z } from 'zod';

import { calculationDataSchema, documentYearQuarterSchema, peppolStatusSchema, transportTypeSchema } from '../common/schemas';

export const creditNoteStatusSchema = z.enum(['InReview', 'Approved']);

export const creditNoteSchema = z.object({
  id: z.number(),
  invoiceId: z.number(),
  clientId: z.number(),
  contactId: z.number(),
  brandId: z.number().nullable(),
  status: creditNoteStatusSchema,
  description: z.string(),
  reason: z.string(),
  fcEntryNumber: z.string(),
  documentDate: z.string(),
  fcTransportType: transportTypeSchema.exclude(['EmailFallbackForPeppol']).nullable(),
  fcPeppolStatus: peppolStatusSchema.nullable(),
  coTransportType: transportTypeSchema.nullable(),
  coPeppolStatus: peppolStatusSchema.nullable(),
  calculationData: calculationDataSchema,
});

export const creditNoteFiltersSchema = z.object({
  clientIds: z.array(z.number()),
  brandIds: z.array(z.number()),
  years: z.array(z.number()),
  quarters: z.array(documentYearQuarterSchema),
  statuses: z.array(creditNoteStatusSchema),
});
